query liabilityEvent(
  $id: UUID!
) {
  liabilityEvent: eventByEventId(eventId: $id) {
    eventId
    eventName
    sportId
    inLimbo
    sport {
        sportLabel
    }
    competitionId
    competitors
    competition {
        competitionName
    }
    matchState
    isUsaView
    source
    startsAt


    globalEventLiabilities: globalEventLiabilitiesByEventId {
        nodes {
          betsCount
          pnl
          volume
        }
    }
    eventLiabilities: eventLiabilitiesByEventId {
        nodes {
            betsCount
            pnl
            volume
            operatorId
        }
    }
    globalMarketLiabilities: globalMarketLiabilitiesByEventId {
        nodes {
          marketCode
          marketSummary
          marketType
          betsCount
          pnl
          volume
        }
    }
    marketLiabilities: marketLiabilitiesByEventId {
        nodes {
            marketId
            marketCode
            marketSummary
            marketType
            betsCount
            pnl
            volume
            operatorId
        }
    }
    globalSelectionLiabilities: globalSelectionLiabilitiesByEventId {
        nodes {
            selectionType
            marketType
            betsCount
            pnl
            volume
        }
    }
    selectionLiabilities: selectionLiabilitiesByEventId {
        nodes {
            marketId
            selectionId
            selectionType
            betsCount
            pnl
            volume
            operatorId
        }
    }
  }
}
